// extracted by mini-css-extract-plugin
module.exports = {"container":"HomeSearchSkeleton_container__zCRxh"};